
export const getLocale = () => {
  let languages = [];

  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languages = languages.concat(window.navigator.languages);
    }
    if (window.navigator.language) {
      languages.push(window.navigator.language);
    }
    if (window.navigator.userLanguage) {
      languages.push(window.navigator.userLanguage);
    }
    if (window.navigator.browserLanguage) {
      languages.push(window.navigator.browserLanguage);
    }
    if (window.navigator.systemLanguage) {
      languages.push(window.navigator.systemLanguage);
    }
  }

  languages.push('pl');

  return [...new Set(languages.map(l => l.substr(0, 2)))];
}
